import { Feature } from "@pentacode/core";

type FeatureBearer = { features: Feature[] } | null | undefined;

// Registers the `ptc-assistant-chat-floating` chunk for voice-control-AI companies.
// Idempotent (the dynamic import is cached), so it is safe to call from every entry
// point that makes a company available: app init and post-login.
export function ensureAssistantLoaded(
    company: FeatureBearer,
    load: () => void = () => void import("./chat-integration-floating")
): boolean {
    if (!company?.features.includes(Feature.voiceControlAi)) {
        return false;
    }
    load();
    return true;
}
